<ag-shr-modal-window #needToKnowModalRef [title]="'Need To Know'" [showSaveButton]="false">
  <ag-shr-need-to-know-grid
    [agentId]="agentId$ | async"
    [sourceType]="sourceType"
    [canEdit]="canEdit"
    [canCreate]="canCreate"
    [canDelete]="canDelete"
  ></ag-shr-need-to-know-grid>
</ag-shr-modal-window>

<ag-shr-editor-toolbar
  [title]="'Need To Know'"
  [agentDbId]="agentId$ | async"
  [isEditVisible]="canEdit"
  (clickEdit)="showListPopup()"
></ag-shr-editor-toolbar>

<ag-shr-need-to-know-grid
  class="need-to-know__data-grid"
  [title]="''"
  [agentId]="agentId$ | async"
  [sourceType]="sourceType"
  [isEditable]="false"
></ag-shr-need-to-know-grid>
